import { BreakpointsOptions } from '@mui/system'

const breakpoints: BreakpointsOptions = {
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  values: {
    xs: 576, // Mobile
    sm: 768, // Mobile
    md: 992, // Desktop
    lg: 1200, // Desktop
    xl: 1201, // Desktop
  },
}

export default breakpoints
